import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AuthLayout from '@/layouts/auth/AuthSplitLayout.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  props: {
    title: {},
    description: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthLayout, {
    title: _ctx.title,
    description: _ctx.description
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["title", "description"]))
}
}

})